import { Provider } from '@angular/core';
import { environment } from 'src/environments/environment';

export * from './app-insights.service';
export * from './google-analytics.service';

/**
 * Since last update (Angular 14) :
 *
 * Wanted to use GoogleTagManagerConfiguration.set but the lib is poorly written and the author forgot to export GoogleTagManagerConfiguration in public-api.ts so we can't import it properly.
 *
 * So we use 3 providers for each value instead of 1 provider for the whole object, since it's handled by the GoogleTagManagerService (see ctor : https://github.com/mzuccaroli/angular-google-tag-manager/blob/761c7ae2dd0711d7ab4f2003aef40329e93dcf7a/projects/angular-google-tag-manager/src/lib/angular-google-tag-manager.service.ts#L21-L31)
 */
export const GA_CONFIG_PROVIDERS: Provider[] = [
  {
    provide: 'googleTagManagerId',
    useValue: environment.googleTagManager.id,
  },
  {
    provide: 'googleTagManagerAuth',
    useValue: environment.googleTagManager.auth,
  },
  {
    provide: 'googleTagManagerPreview',
    useValue: environment.googleTagManager.preview,
  },
];
